// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2Z-r9","bigColWidth":"Table_bigColWidth__1rBtx","biggerColWidth":"Table_biggerColWidth__19d49","row":"Table_row__A2W_x","col":"Table_col__20lXp"};